import React, {useEffect, useState} from "react";
import MDInput from "../../../components/MDInput";
import {Grid, NativeSelect} from "@mui/material";
import MDBox from "../../../components/MDBox";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";
import {getFamilyMemberTypes} from "../../common/api/WebApi";
import {useForm} from "react-hook-form";
import {handleDefaultValues, isValidDob, DOB_INPUT_MIN, DOB_INPUT_MAX} from "../../common/Utils";

export default function CartFamilyMembers({cart, callback}) {

  const [formValid, setFormValid] = useState(false);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [dob, setDob] = useState();
  const [familyMemberTypes, setFamilyMemberTypes] = useState([]);
  const [typesReady, setTypesReady] = useState(false);
  const [isChild, setIsChild] = useState(false);
  const [familyMemberType, setFamilyMemberType] = useState({id: -1});

  const checkFormValid = () => {
    let isValid = firstName && lastName && familyMemberType?.id >= 1;
    if (isValid && isChild) {
      isValid = isValid && dob;
    }
    setFormValid(isValid);
    let form = {
      firstName: firstName,
      lastName: lastName,
      dob: dob,
      familyMemberType: familyMemberType,
      valid: isValid
    }
    callback(form);
  }

  useEffect(() => {
    checkFormValid();
  }, [firstName, lastName, dob, familyMemberType]);

  useEffect(() => {
    getFamilyMemberTypes().then(result => {
      if (result.error) {
      } else {
        setFamilyMemberTypes(result);
        setTypesReady(true);
        setValue('familyMemberType.id', 1);
        setFamilyMemberType({id: 1});
        setIsChild(true);
      }
    });
  }, []);

  const {register, handleSubmit, setValue, control, formState: {errors}} = useForm({
    values: handleDefaultValues({})
  });

  return (
    <>
      <div>
        <MDBox>
          <Grid container p={1}>
            <Grid item xs={12} sm={6} p={1}>
              <div className="form-group">
                <label htmlFor="firstName">First Name</label>
                <MDInput
                  onChange={(e) => {
                    setFirstName(e.target.value)
                  }}
                  variant="outlined" type="text" required
                  name="firstName"
                  autoComplete="off"
                  className="form-control"
                  id="firstName"
                  placeholder="Enter First name"/>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} p={1}>
              <div className="form-group">
                <label htmlFor="lastName">Last Name </label>
                <MDInput
                  onChange={(e) => {
                    setLastName(e.target.value)
                  }}
                  autoComplete="off"
                  variant="outlined" type="text" required
                  name="lastName"
                  className="form-control" id="lastName"
                  placeholder="Enter Last name"/>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} p={1}>
              <div className="form-group">
                <label htmlFor="state">Family Member Type</label>
                {typesReady && <NativeSelect required
                                             id={'familyMemberType'}
                                             variant="outlined"
                                             name={'familyMemberType'} className={'form-control'}
                                             {...register('familyMemberType.id', {
                                               required: true,
                                               min: 1,
                                               onChange: ((e) => {
                                                 setIsChild(parseInt(e.target.value, 10) === 1)
                                                 setFamilyMemberType({
                                                   id: parseInt(e.target.value, 10)
                                                 })
                                               })
                                             })} >
                  {
                    familyMemberTypes.map((c) =>
                      <option value={c.id} key={c.id}>
                        {c.name}
                      </option>)
                  }
                </NativeSelect>}
              </div>
            </Grid>
            <Grid item xs={12} sm={6} p={1}>
              {isChild && <div className="form-group">

                <label htmlFor="dob">Birthday</label>
                <div className={'input-group'}>
                  <input
                    required={isChild}
                    {...register('dob', {
                      required: isChild,
                      validate: (value) => !isChild || isValidDob(value) || 'Please enter a valid birth date'
                    })}
                    className={`form-control${errors.dob ? ' is-invalid' : ''}`}
                    type="date"
                    min={DOB_INPUT_MIN}
                    max={DOB_INPUT_MAX}
                    onChange={(e) => {
                      setDob(isValidDob(e.target.value) ? new Date(e.target.value) : undefined);
                    }}
                  />
                </div>
                {errors.dob && <div className="invalid-feedback d-block">{errors.dob.message}</div>}
              </div>
              }

            </Grid>
          </Grid>
        </MDBox>
      </div>
    </>
  )
}